function resizeSelect(select) {
  const temp = document.createElement('span');
  temp.style.visibility = 'hidden';
  temp.style.position = 'absolute';
  temp.style.whiteSpace = 'nowrap';
  temp.style.font = getComputedStyle(select).font;
  temp.textContent = select.options[select.selectedIndex].text;

  document.body.appendChild(temp);
  select.style.width = temp.offsetWidth + 60 + 'px';
  document.body.removeChild(temp);
}

// Initial resize on load

document.addEventListener('DOMContentLoaded', () => {
  const crumbsSelect = document.querySelector('[data-service-select]');
  if (crumbsSelect) {
    crumbsSelect.addEventListener('change', (e) => {
      const selectedOption = e.target.options[e.target.selectedIndex];
      const url = selectedOption.getAttribute('data-url');
      if (url) {
        window.location.href = url;
      }
    });
    resizeSelect(crumbsSelect);
  }
});
